import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { formatPercentage } from '../../../utils/format';
var TypicaHandlingFeeExplanation = function (_a) {
    var isTypicaStockOrder = _a.isTypicaStockOrder, typicaHandlingRates = _a.typicaHandlingRates, exclusiveTypicaHandlingRate = _a.exclusiveTypicaHandlingRate, selectionHandlingRateVersion = _a.selectionHandlingRateVersion;
    var t = useTranslation().t;
    var typicaStockHandlingFeeExplanationLabel = React.useMemo(function () {
        switch (selectionHandlingRateVersion) {
            case 'v0':
                return 'typicaExplanationForTypicaSelection';
            case 'v1':
                return 'typicaExplanationForTypicaSelectionByWeightV1';
            case 'v2':
                return 'typicaExplanationForTypicaSelectionByWeightV2';
        }
    }, [selectionHandlingRateVersion]);
    var explanation = React.useMemo(function () {
        if (isTypicaStockOrder) {
            var key = typicaStockHandlingFeeExplanationLabel;
            return t("pages.invoice.transparencyInformation.".concat(key));
        }
        if (exclusiveTypicaHandlingRate) {
            return t('pages.invoice.transparencyInformation.typicaExplanationForExclusiveLot', {
                exclusiveTypicaHandlingRate: formatPercentage(exclusiveTypicaHandlingRate),
            });
        }
        if (Object.keys(typicaHandlingRates).includes('less_than_5_bags')) {
            var rate_1 = typicaHandlingRates;
            return t('pages.invoice.transparencyInformation.typicaExplanationByBagCount', {
                lessThan5Bags: formatPercentage(rate_1['less_than_5_bags']),
                moreThan5Bags: formatPercentage(rate_1['more_than_5_bags']),
                moreThan10Bags: formatPercentage(rate_1['more_than_10_bags']),
                moreThan50Bags: formatPercentage(rate_1['more_than_50_bags']),
            });
        }
        var rate = typicaHandlingRates;
        return t('pages.invoice.transparencyInformation.typicaExplanationByWeight', {
            lessThan300Kg: formatPercentage(rate['less_than_300kg']),
            moreThan300Kg: formatPercentage(rate['more_than_300kg']),
            moreThan600Kg: formatPercentage(rate['more_than_600kg']),
            moreThan3000Kg: formatPercentage(rate['more_than_3000kg']),
        });
    }, [
        t,
        isTypicaStockOrder,
        typicaHandlingRates,
        exclusiveTypicaHandlingRate,
        typicaStockHandlingFeeExplanationLabel,
    ]);
    return (React.createElement(Typography, { variant: (isTypicaStockOrder && selectionHandlingRateVersion === 'v0') ||
            exclusiveTypicaHandlingRate
            ? 'body1'
            : 'caption' }, explanation));
};
export default TypicaHandlingFeeExplanation;
